import clsx from 'clsx';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import Cookies from 'universal-cookie';

import { User } from '@utils/backend-api/currentUser';

import { PrimaryButton, SecondaryButton } from '../Button/variants';
import IconClose from '../Images/Rebranding/IconClose';
import IconTI from '../Images/Rebranding/IconTI';

interface DonwloadAppModalProps {
  articleSlug?: string;
  isArticle?: boolean;
  appStoreUrl: string;
  currentUser: User;
}

const cookies = new Cookies();

const ViewInAppModal = ({
  articleSlug,
  isArticle,
  appStoreUrl,
  currentUser,
}: DonwloadAppModalProps) => {
  const [visible, setVisible] = useState(false);
  const cookieName = 'closedAppModal';
  const cookieExpires = moment().add(isArticle ? 1 : 7.3, 'days');
  const onelinkUrl = new URL('https://theinformation.onelink.me/6IaG/3stnun15');

  useEffect(() => {
    const previouslyDismissed = cookies.get(cookieName);
    if (!previouslyDismissed) setVisible(true);
  }, []);

  if (articleSlug) {
    onelinkUrl.search = `article=${articleSlug}`;
  }

  if (!isArticle && (!currentUser?.is_subscriber || currentUser?.app_first_open_at)) {
    return null;
  }

  return (
    <section
      id="ViewInAppModal"
      className={clsx(
        'fixed bottom-0 left-0 z-[10000] w-full bg-grayscale-charcoal px-24 pb-32 pt-16 transition-transform',
        !visible ? 'translate-y-full' : 'delay-500'
      )}
    >
      <IconClose
        id="ViewInAppModal-close"
        className="absolute right-24 top-16 w-28 cursor-pointer text-white"
        strokeWidth="1"
        onClick={() => {
          cookies.set(cookieName, 'true', {
            expires: cookieExpires.toDate(),
          });
          setVisible(false);
        }}
      />

      <div className="m-auto flex h-48 w-48 items-center justify-center rounded-6 bg-primary-magenta">
        <IconTI className="w-24 text-white" />
      </div>

      {isArticle && currentUser?.app_first_open_at ? (
        <PrimaryButton
          as="externalLink"
          size="small"
          fullWidth
          href={onelinkUrl.toString()}
          className="mt-16"
        >
          Read in app
        </PrimaryButton>
      ) : (
        <>
          <h3 className="mb-20 mt-12 font-suisse-works text-headline-sm text-white">
            Read this article in The&nbsp;Information App
          </h3>
          <SecondaryButton
            as="externalLink"
            size="small"
            fullWidth
            href={onelinkUrl.toString()}
            className="mb-24 border-white text-white"
          >
            Open the app
          </SecondaryButton>
          <PrimaryButton as="externalLink" size="small" fullWidth href={appStoreUrl}>
            Download App
          </PrimaryButton>
        </>
      )}
    </section>
  );
};

export default ViewInAppModal;
